import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#00B4D2",
        d: "M12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24m-1.875-8.25h1.125v-3h-1.125A1.12 1.12 0 0 1 9 11.625c0-.623.502-1.125 1.125-1.125h2.25c.623 0 1.125.502 1.125 1.125v4.125h.375c.623 0 1.125.502 1.125 1.125S14.498 18 13.875 18h-3.75A1.12 1.12 0 0 1 9 16.875c0-.623.502-1.125 1.125-1.125M12 6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }